import { useMemo, useState } from "react"
import { Add, Error, Refresh } from "@mui/icons-material"
import { IconButton, Menu, MenuItem } from "@mui/material"
import { map, size } from "lodash"
import EditSwap from "connected-components/edit-swap"
import EditWatchlist from "components/edit-watchlist"
import EditPortfolio from "modules/edit-portfolio"
import ResearchTopicCreate from "modules/research-topic-create"
import { useModels } from "resources/models"
import { useIsOpPro } from "resources/account"
import { Creators as ResourcesCreators } from "modules/resources/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { useDispatch } from "react-redux"
import { track } from "helpers/analytics"
import Tooltip from "components/material/tooltip"

function createMenuOptions(isOpPro) {
  const options = [{
    id: "portfolio",
    label: "Portfolio",
  }, {
    id: "watchlist",
    label: "Watchlist",
  }, {
    id: "basket",
    label: "Basket",
  }]

  if (!isOpPro) {
    options.push({
      id: "topic",
      label: "Research Topic",
    })
  }
  return options
}

export default function CreateResource() {
  const [menuAnchor, setMenuAnchor] = useState(false)
  const dispatch = useDispatch()
  const isOpPro = useIsOpPro()
  const [models, status] = useModels()

  const options = useMemo(() => createMenuOptions(isOpPro), [isOpPro])

  if (status === "loading") {
    return <IconButton disabled className="spin">
      <Refresh />
    </IconButton>
  }

  if (status === "error") {
    return <IconButton disabled>
      <Error />
    </IconButton>
  }

  const noModels = !size(models)

  const openCreateBasket = () => {
    dispatch(DialogCreators.open({
      title: "Create Basket",
      content: <EditSwap saveSwap={(...args) => dispatch(ResourcesCreators.createSwap(...args))} />,
    }))
  }

  const openCreateWatchlist = () => {
    dispatch(DialogCreators.open({
      title: "Create Watchlist",
      content: <EditWatchlist heapSubmitId="home-create-watchlist" saveWatchlist={(...args) => dispatch(ResourcesCreators.createWatchlist(...args))} />,
    }))
  }

  const openCreatePortfolio = () => {
    dispatch(DialogCreators.open({
      title: "Add Portfolio",
      content: <EditPortfolio savePortfolio={(...args) => dispatch(ResourcesCreators.createPortfolio(...args))} />,
    }))
  }

  const openCreateTopic = () => {
    dispatch(DialogCreators.open({
      content: <ResearchTopicCreate setModel={(...args) => dispatch(ResourcesCreators.setModel(...args))} />,
    }))
  }

  const toggleCreate = (createType) => {
    return () => {
      switch (createType) {
        case "basket":
          openCreateBasket()
          break
        case "watchlist":
          openCreateWatchlist()
          break
        case "topic":
          openCreateTopic()
          break
        default:
          openCreatePortfolio()
          break
      }

      track("resources-create", {
        resourceType: createType,
      })
      setMenuAnchor(null)
    }
  }

  return <>
    <Tooltip key="create" title={noModels ? "Create resource is disabled since you do not have access to a risk model." : "Create resource"}>
      <span>
        <IconButton
          disabled={noModels}
          key="create-resource"
          color="primary"
          className="create-resource desktop-button"
          onClick={(event) => {
            if (menuAnchor) {
              setMenuAnchor(null)
            } else {
              setMenuAnchor(event.currentTarget)
            }
          }}
          size="large"
        >
          <Add />
        </IconButton>
      </span>
    </Tooltip>
    <Menu
      open={!!menuAnchor}
      anchorEl={menuAnchor}
      onClose={() => setMenuAnchor(null)}
      classes={{ paper: "resources-sort-filter-menu create-resource-menu" }}
    >
      <MenuItem disabled className="menu-title">Create New</MenuItem>
      {map(options, (option) =>
        <MenuItem key={option.id} onClick={toggleCreate(option.id)}>
          {option.label}
        </MenuItem>,
      )}
    </Menu>
  </>
}
